export const isUndefined = value => typeof value === 'undefined'
export const isNull = value => value === null
export const isEqual = (value1, value2) => value1 === value2

export const isString = value => typeof value === 'string' || value instanceof String

export const len = value => {
  if (Array.isArray(value) || isString(value)) {
    return value.length
  }

  return 0
}

export const isEmpty = value => len(value) === 0

export const isJSON = value => {
  try {
    JSON.parse(value)
  } catch (e) {
    return false
  }
  return true
}

export const readFile = file => {
  return new Promise(resolve => {
    const reader = new FileReader()
    reader.addEventListener('load', () => resolve(reader.result), false)
    reader.readAsDataURL(file)
  })
}
